import { TFunction } from 'i18next'
import { z } from 'zod'

export const createNewsSchema = (t: TFunction) =>
  z.object({
    title: z.string().min(1, {
      message: t('required'),
    }),
    imageFileId: z.string(),
    content: z.string().min(1, {
      message: t('required'),
    }),
  })
